//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/demeter/actions';
import type { SubmittedForm$Props } from './flowTypes'

class SubmittedForm extends React.Component<SubmittedForm$Props> {
    componentWillUpdate(){
        const { demeter } = this.props;
    
        if (demeter.invoiceSubmitted) {
            this.props.invoiceSubmissionCompleted();
        }
    }

    render(){
        return (
            <div className="container">
                <div className="row">
                    <br />
                </div>
                <div className="row">
                    <h3>Invoice Data Extraction</h3>
                </div>
                <div className="row">
                    <div className="alert alert-success" role="alert">
                         Your task has been submitted successfully.
                    </div>
                </div>    
            </div>
        )
    }
    
}

const mapStateToProps:any = (state, ownProps) => {
    return {
        demeter: state.demeter
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      invoiceSubmissionCompleted: () => {
         dispatch(actions.invoiceSubmissionCompleted())  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(SubmittedForm);


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/SubmittedForm.js